const autoNgTemplateLoaderTemplate1 = require('./template.html');

angular.module('shbdeployer.kubernetes').component('kubernetesApplicationPlacementsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesApplicationPlacementsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    refreshCallback: '<',
    loading: '<',
    removeAction: '<',
  },
});
